module.exports = __webpack_public_path__ + "img/close_square.78204ecf.svg";